const useStyles = theme => ({
    wmMobileTop: {
        background: '#024731',
        position: 'fixed',
        padding: '2em 2em 1em 2em',
        width: '110%',
        marginLeft: '-2em',
        marginTop: '-1em',
    },
    wmMobileTopLS: {
        background: '#024731',
        position: 'fixed',
        padding: '2em 2em 1em 2em',
        width: '100%',
        marginLeft: '-1.5em',
        marginTop: '-1.5em',
    },
    chapterName: {
        fontFamily: 'Maax-Bold',
        color: '#BED600',
        padding: '15px 10px 10px 10px',
        fontSize: '0.9em',
    },
    pageArrow: {
        color: 'white',
        fontSize: '1em',
        fontWeight: 'bold',
        cursor: 'pointer',
    },
    pageArrowDisabled: {
        color: '#024731',
        fontSize: '1em',
    },
    largeTitle: {
        fontFamily: 'Maax-Bold',
        fontSize: '1.5em',
        color: 'white',
        textAlign: 'center',
        marginTop: '1em',
        marginBottom: '5px',
    },
    mediumTitle: {
        fontFamily: 'Maax-Bold',
        fontSize: '1em',
        color: 'white',
        textAlign: 'center',
        marginTop: '2em',
        marginBottom: '5px',
    },
    smallTitle: {
        fontFamily: 'Maax-Bold',
        fontSize: '0.6em',
        color: 'white',
        textAlign: 'center',
        marginBottom: '5px',
    },
    largeText: {
        fontFamily: 'Maax-Bold',
        fontSize: '1.5em',
        marginTop: '5px',
        marginBottom: '0.5em',
        color: 'white',
        textAlign: 'center',
    },
    extralargeText: {
        fontFamily: 'Maax-Bold',
        fontSize: '3em',
        marginTop: '10px',
        marginBottom: '0.5em',
        color: 'white',
        textAlign: 'center',
    },
    noticeText: {
        fontFamily: 'Maax-Bold',
        fontSize: '4em',
        marginTop: '5px',
        marginBottom: '0.5em',
        color: 'white',
        textAlign: 'center',
    },
    wmHR: {
        border: '0.5px solid white',
        width: '45%',
        margin: 'auto',
        textAlign: 'center',
    },
    wmHR2: {
        border: '0.5px solid white',
        width: '30%',
        margin: 'auto',
        textAlign: 'center',
    },
    lastgroupDiv: {
        margin: 'auto',
        border: '1px solid white',
        width: '90%',
        minHeight: '120px',
        display: 'flex',
    },
    leftDiv: {
        backgroundColor: 'white',
        width: '30%',
        minHeight: '120px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    groupTitle: {
        fontFamily: 'Maax-Bold',
        color: '#024731',
        marginBottom: '1em',
        fontSize: '0.9em',
        WebkitTextFillColor: 'white',
        WebkitTextStrokeWidth: '0.5px',
        WebkitTextStrokeColor: '#024731',
    },
    groupText: {
        fontFamily: 'Maax-Bold',
        color: '#024731',
        textAlign: 'center',
        fontSize: '0.9em',
    },
    rightDiv: {
        width: '70%',
        minHeight: '120px',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        alignItems: 'center',
        '& span': {
            padding: '10px',
            fontFamily: 'Maax-Bold',
            fontSize: '0.6em',
            display: 'inline-block',
            color: 'white',
        },
    },
    chartLegend: {
        width: '5px',
        height: '5px',
        display: 'inline-block',
    },
    legendText: {
        color: 'white',
        fontFamily: 'Maax-Bold',
        fontSize: '0.5em',
        paddingLeft: '5px',
    },
    wmLeaderboardDiv: {
        background: '#BED600',
        width: '100vw',
        margin: '-2em',
        paddingBottom: '1.5em',
    },
    wmTableTitle: {
        fontFamily: 'Maax-Bold',
        textAlign: 'center',
        fontSize: '1.5em',
        color: '#024731',
    },
    wmTableContainer: {
        width: '90%',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginTop: '2em',
    },
    wmTable: {
        color: '#024731',
        marginTop: '1em',
        borderCollapse: 'collapse',
    },
    wmTableLS: {
        color: '#024731',
        marginTop: '1em',
        borderCollapse: 'collapse',
        width: '100%',
    },
    wmTableHead: {
        fontFamily: 'Maax-Bold',
        padding: '10px',
        fontSize: '1em',
    },
    wmTableRow: {
        fontFamily: 'Maax',
        padding: '10px',
        fontSize: '1em',
    },
    wmTableUser: {
        fontFamily: 'Maax-Bold',
        padding: '10px',
        fontSize: '1em',
        color: '#BED600',
        border: '1px solid #024731',
    },
    pageArrow2: {
        color: '#024731',
        fontSize: '1em',
        fontWeight: 'bold',
        cursor: 'pointer',
        padding: '5px',
    },
    pageArrowDisabled2: {
        color: '#BED600',
        fontSize: '1em',
    },
    currentPage: {
        cursor: 'pointer',
        fontSize: '0.9em',
        paddingTop: '2px',
        color: '#024731',
    },
    otherPage: {
        cursor: 'pointer',
        fontSize: '0.9em',
        paddingTop: '2px',
        color: 'white',
    },
    searchBar: {
        width: '100%',
        padding: '5px 10px 5px 10px',
        border: '1px solid white',
        borderRadius: '5px',
        background: 'transparent',
        color: 'white',
        fontFamily: 'Maax',
        fontSize: '1em',
        float: 'left',
        "&:focus": {
		    outline: '1px solid #024731',
		},
    },
});

export default useStyles;